type KeyEvent = { keyCode: number };
type KeyUpHandler = (event: KeyEvent) => void;

const handleKeyUp = (keyCode: number, handler: KeyUpHandler) => (event: KeyEvent) => {
  event.keyCode === keyCode && handler(event);
};

export const handleEnterKeyUp = (handler: KeyUpHandler) => (event: KeyEvent) =>
  handleKeyUp(13, handler)(event);
export const handleEscapeKeyUp = (handler: KeyUpHandler) => (event: KeyEvent) =>
  handleKeyUp(27, handler)(event);
export const handleTabKeyUp = (handler: KeyUpHandler) => (event: KeyEvent) =>
  handleKeyUp(9, handler)(event);
